interface NudgeChipsProps {
  onNudgeClick: (nudge: string) => void
}

const NUDGES = [
  { label: 'Work Order Status', icon: 'fa-clipboard-list' },
  { label: 'Payment Methods', icon: 'fa-credit-card' },
  { label: 'Invoice Download', icon: 'fa-file-invoice' },
  { label: 'Turnaround Time', icon: 'fa-clock' },
  { label: 'GST Invoice', icon: 'fa-receipt' },
  { label: 'Contact Support', icon: 'fa-phone' },
]

export default function NudgeChips({ onNudgeClick }: NudgeChipsProps) {
  return (
    <div className="px-4 pb-2">
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">Quick questions:</p>
      <div className="flex flex-wrap gap-2">
        {NUDGES.map((nudge) => (
          <button
            key={nudge.label}
            onClick={() => onNudgeClick(nudge.label)}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-full transition-colors"
          >
            <i className={`fas ${nudge.icon}`}></i>
            {nudge.label}
          </button>
        ))}
      </div>
    </div>
  )
}
